// Content
$(function () {
  if (typeof noTdUtils === 'undefined') {
    let getTimeDatePreferences = async () => {
        if (!window.isLoggedIn) return;
        await AnyStore.inst.preloadSingle("timeDatePreferences");
        if( AnyStore.inst.timeDatePreferences ){
            window.localStorage.setItem(
                'dateTimePreferences',
                JSON.stringify({
                  timezone: AnyStore.inst.timeDatePreferences.Preferences.timezone,
                  dateFormat: AnyStore.inst.timeDatePreferences.Preferences.dateFormat,
                })
            )
        }
    };
    getTimeDatePreferences();

  }

  // Initialise Select2 on all select inputs.
  $(
    'select:not(.select2-hidden-accessible):not(.not-select2):not(.direct-select2)'
  ).select2()

  $('#toggle-menu__input').change(function () {
    $('.main-navigation__list').toggleClass('show')
  })

  $('#close-list').click(function () {
    $('#toggle-menu__input').prop('checked', false)
  })

  $('.launch-option.menu, .nav-hide-menu').click(function (event) {
    $('.main-navigation').toggleClass('show')
  })

  $('.launch-option.basket').click((event) => {
    AnyBasket.inst.reloadContent()
    $('.basket-notice').hide()
    $('#basket__slide').toggleClass('show')
  })

  var el = $('<div class="dropdown__preventDefault"></div>')

  $('.nav__list-item--parent').prepend(el.clone())

  $('.dropdown__preventDefault').click(function () {
    $(this).parent().find('.nav__list-sublist').slideToggle()
  })

  $('#onpage_support_button,.onpage_support_close-button').click(function () {
    $('.onpage_support').fadeToggle(250)
    setTimeout(function () {
      $('.dlg-head-srch__input').focus()
    }, 400)
  })

  $('#vps-power__button,.vps-power__list__close-button').click(function () {
    $('.vps-power__list').fadeToggle()
    $('.overlay.generic').fadeToggle()
  })

  $('#terms-modal__link, #terms-modal__close-button, .overlay.generic').click(
    function () {
      $('#terms-modal').fadeToggle([200])
      $('.overlay.generic').fadeToggle([200])
    }
  )

  $(
    '#ip-confirm-btn, #ip-confirm-btn2, #modal-standard__ip-confirm-close'
  ).click(function () {
    $('#modal-ip-confirm').fadeToggle()
    $('.overlay.generic').fadeToggle()
  })

  function stayLoggedIn() {
    $(document).off('keyup.logout')
    $(
      '.overlay.generic, #logout-options, .vps-power__list, #modal-ip-confirm, .add-services__list'
    ).fadeOut()
  }

  $('#logout-options, #logout-button').click(() => {
    $('#logout-options, .overlay.generic').fadeIn()
    $(document).one('keyup.logout', (event) => {
      if (event.keyCode == 13) {
        if (window.sessionStorage) sessionStorage.clear()

        const default_logout_url = SharedSettings.inst.isOpen
          ? '/basket-summary-login'
          : '/login'

        location.href = `/logout?r=${logoutUrl || default_logout_url}`
      } else if (event.keyCode == 27) {
        stayLoggedIn()
      }
    })
  })
  $('#log-me-out').click(() => {
    if (typeof SharedSettings == 'undefined') {
      // Not HS
      location.href = '/logout'
    } else {
      if (window.sessionStorage) sessionStorage.clear()

      const default_logout_url = SharedSettings.inst.isOpen
        ? '/basket-summary-login'
        : '/login'

      location.href = `/logout?r=${logoutUrl || default_logout_url}`
    }
  })
  $(document).on('click', '.overlay.generic, #stay-logged-in', stayLoggedIn)

  var iScrollPos = 0
  $(window).scroll(function () {
    var iCurScrollPos = $(this).scrollTop()
    var basketNotice = $('.basket-notice')
    if (iCurScrollPos < 80) {
      var diff = 80 - iCurScrollPos
      $(basketNotice).css('top', iCurScrollPos + diff + 'px')
    } else {
      $(basketNotice).css('top', iCurScrollPos + 10 + 'px')
    }
    iScrollPos = iCurScrollPos
  })

  $(document).on('click', '.show-basket-hide-notice', function (event) {
    event.preventDefault()
    $('.basket-notice').hide()
    $(window).scrollTop(0)
    $('#basket__slide').addClass('show')
  })

  if ($('#scroll-top')) {
    $(window).scroll(function () {
      if ($(this).scrollTop() > 400) {
        $('#scroll-top').css('opacity', '1')
      } else {
        $('#scroll-top').css('opacity', '0')
      }
    })
  }

  if (typeof bootstrap !== 'undefined' && bootstrap.Tooltip && !$.fn.tooltip) {
    $.fn.tooltip = function (command) {
      return this.each(function () {
        const tooltip = bootstrap.Tooltip.getOrCreateInstance(this)
        if (typeof command === 'string' && typeof tooltip[command] === 'function') {
          tooltip[command]()
        }
      })
    }
  }

  if (typeof bootstrap !== 'undefined' && bootstrap.Tooltip) {
    new bootstrap.Tooltip(document.body, {
      selector: '[data-bs-toggle="tooltip"]'
    })
  }
})

function autotable() {
  /** @type {NodeListOf<HTMLTableElement>} */
  const tables = document.querySelectorAll('table[data-autotable]')
  for (const t of tables) {
    delete t.dataset.autotable
    t.classList.add('table')
    const headers = t.querySelectorAll('thead > tr > th')
    const header_labels = []
    for (const h of headers) {
      header_labels.push(h.textContent)
    }
    /** @type {NodeListOf<HTMLTableRowElement>} */
    const rows = t.querySelectorAll('tbody > tr')
    for (const r of rows) {
      if (r.dataset['skip-autotable']) {
        delete r.dataset['skip-autotable']
      } else {
        /** @type {NodeListOf<HTMLTableCellElement>} */
        const cells = r.querySelectorAll('td, th')
        for (let i = 0; i < cells.length; i++) {
          cells[i].dataset.title = header_labels[i]
        }
      }
    }
  }
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

class Site {
  /**
   * @type {?boolean}
   */
  static get translateEnabled() {
    if (localStorage.hasOwnProperty('googleTranslate')) {
      return !!+localStorage.googleTranslate
    } else {
      return null
    }
  }
  static set translateEnabled(v) {
    if (v && !this.translateEnabled) {
      this.translate().then(() => $('#google_translate_element').show())
    }
    if (v === null) {
      delete localStorage.googleTranslate
    } else {
      localStorage.googleTranslate = +v
    }
  }
  /**
   * @param {{$nextTick(Function)}} vue
   * @param {{[selector: string]: {act: () => void, oldOffset?: number}}} markers
   */
  static checkInfiniteScroll(vue, markers) {
    let existing_offset
    const scroll_top = $(window).scrollTop()
    const window_height = $(window).height()
    /**
     * @type {typeof markers}
     */
    const recheck = {}
    for (const [selector, config] of Object.entries(markers)) {
      if (
        (existing_offset = $(selector).offset()) &&
        (!config.oldOffset || existing_offset.top > config.oldOffset) &&
        scroll_top !== undefined &&
        window_height &&
        scroll_top + window_height > existing_offset.top
      ) {
        config.act()
        recheck[selector] = Object.assign({}, config, {
          oldOffset: existing_offset.top,
        })
      }
    }
    if (Object.keys(recheck).length) {
      vue.$nextTick(() => this.checkInfiniteScroll(vue, recheck))
    }
  }
  /**
   * @param {Function} scroll_listener
   */
  static deinitInfiniteScroll(scroll_listener) {
    window.removeEventListener('scroll', scroll_listener)
  }
  static hidePage() {
    document.body.style.opacity = '0'
  }
  /**
   * @param {{$nextTick(Function)}} vue
   * @param {{[selector: string]: {act: () => void, oldOffset?: number}}} markers
   * @return {Function} the function listening to the scroll event, so you can
   * remove it
   */
  static initInfiniteScroll(vue, markers) {
    vue.$nextTick(() => Site.checkInfiniteScroll(vue, markers))
    const scroll_listener = () => {
      Site.checkInfiniteScroll(vue, markers)
    }
    window.addEventListener('scroll', scroll_listener)
    return scroll_listener
  }
  /**
   *
   * @param {string} selector
   */
  static initNarrow(selector) {
    /** @type {HTMLTableElement[]} */
    //@ts-ignore
    const tables = document.querySelectorAll(selector + ' table.table')
    for (const table of tables) {
      if (table.tHead) {
        /** @type {string[]} */
        const titles = []
        const tr = table.tHead.rows[0]
        for (const c of tr.cells) {
          titles.push(c.textContent || '')
        }
        for (const tb of table.tBodies) {
          const tr = tb.rows[0]
          for (let i = 0; i < tr.cells.length; i++) {
            const c = tr.cells[i]
            if (titles[i]) {
              c.dataset.title = titles[i]
            }
          }
        }
      }
    }
  }
  static async optionalTranslate() {
    if (this.translateEnabled) {
      await this.translate()
    }
  }
  static optionalTranslateSelect() {
    if (this.translateEnabled) {
      $('#google_translate_element').show()
    }
  }
  /**
   * @param {string} p
   * @return {Promise<*>}
   */
  static async require_once(p) {
    if (!this.required[p]) {
      for (const s of document.querySelectorAll(
        'script:not([data-required-by])'
      )) {
        this.required[s.getAttribute('src')] = new Promise((resolve) =>
          resolve()
        )
        if (s.src) {
          //@ts-ignore
          s.dataset.requiredBy = 'page'
        }
      }
    }
    if (!this.required[p]) {
      this.required[p] = new Promise((resolve, reject) => {
        const script = document.createElement('script')
        script.src = p
        script.dataset.requiredBy = 'site'
        document.body.appendChild(script)
        script.addEventListener('load', resolve)
        script.addEventListener('error', reject)
      })
    }
    return this.required[p]
  }
  /**
   *
   * @param {number} over_seconds
   */
  static showPage(over_seconds = 0) {
    if (over_seconds) {
      document.body.style.transition = `opacity ${over_seconds}s ease-in-out`
    }
    document.body.style.opacity = '1'
  }
  static async translate() {
    await this.require_once(
      '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit'
    )
  }
}
/**
 * @type {{[src: string]: Promise<*>}}
 */
Site.required = {}

Site.Format = {
  /**
   * @param {?(Date|string)} d
   * @param {{ format: ?(boolean|string), time: boolean, utc: boolean }} options
   * @returns {?string}
   */
  date(d, options = { format: true, time: false, utc: false }) {
    return d && tdUtils.createDate(d, options)
  },
  /**
   * @param {?(Date|string)} d
   * @param {{ format: ?(boolean|string), time: boolean, utc: boolean }} options
   * @returns {?string}
   */
  dateString(ds, options = { format: true, time: false, utc: false }) {
    return ds && this.date(ds, options)
  },
  /**
   * @param {?(Date|string)} d
   * @param {{ format: ?(boolean|string), time: boolean, utc: boolean }} options
   * @returns {?string}
   */
  dateTime(d, options = { format: true, time: true, utc: false }) {
    return d && tdUtils.createDate(d, options)
  },
  /**
   * @param {?(Date|string)} d
   * @param {{ format: ?(boolean|string), time: boolean, utc: boolean }} options
   * @returns {?string}
   */
  dateTimeString(ds, options = { format: true, time: true, utc: false }) {
    return ds && this.dateTime(ds, options)
  },
  /**
   * @param {?(Date|string)} d
   * @param {{ format: ?(boolean|string), time: boolean, utc: boolean }} options
   * @returns {?string}
   */
   dateTimeStringFromNow(ds, options = { format: true, time: true, utc: false }) {
    return ds && tdUtils.getMoment(ds).fromNow();
  },
  /**
   *
   * @param {?number} bytes
   * @returns {?string} eg. "10MB"
   */
  GB(bytes) {
    if (bytes === null) return null
    if (bytes == Infinity) return translation.get('global_ublimited')
    return Math.round(bytes / 2 ** 30) + 'GB'
  },
  /**
   * @param {?number} bytes
   * @returns {?string} eg. "10MB"
   */
  GBorMB(bytes) {
    if (this.preferGB) {
      return this.GB(bytes && (bytes * 1024) / 1000)
    } else {
      return this.MB(bytes)
    }
  },
  /**
   *
   * @param {?number} bytes
   * @returns {?string} eg. "10MB"
   */
  MB(bytes) {
    if (bytes === null) return null
    if (bytes == Infinity) return translation.get('global_ublimited')
    return Math.round(bytes / 2 ** 20) + 'MB'
  },
  /**
   * @param {Date|string} d
   * @param {{ format: ?(boolean|string) }} options
   * @returns {string} eg. "January 2019"
   */
  month(d, options = { format: null }) {
    return (
      d &&
      tdUtils.createDate(d, options).format('MMMM YYYY')
    )
  },
  /**
   * @param {string} m eg. "2019-01"
   * @param {{ format: ?(boolean|string) }} options
   * @returns {string} eg. "January 2019"
   */
  monthString(m, options = { format: null }) {
    return this.month(m.substring(0, 7) + '-01T12:00:00Z', options)
  },
  /**
   *
   * @param {?number} n
   * @returns {?string} eg. "Unlimited"
   */
  number(n) {
    if (n === null) return null
    if (n == Infinity) return translation.get('global_ublimited')
    return `${n}`
  },
  /**
   *
   * @param {?number} months
   * @returns {?string} eg. "every year"
   */
  periodMonths(months) {
    if (months === null) return null
    if (months % 12) {
      if (months == 1) return translation.get('global_every_month')
      else return translation.sprintf(
        translation.get('global_every_number_months'),
        [String(months)]
    )
    } else {
      const y = months / 12
      if (y == 1) {
        return translation.get('global_every_year')
      } else {
        return translation.sprintf(
          translation.get('global_every_number_years'),
          [String(y)]
        )
      }
    }
  },
  /**
   * The locale used to format a currency when its entry in
   * Catalogue.currencies doesn't name one of its own.
   */
  defaultCurrencyLocale: 'en-GB',
  /**
   * Cache of Intl.NumberFormat instances, keyed by currency code. Building one
   * is expensive and pages such as the domain tables format hundreds of prices.
   *
   * @type {{[currency: string]: Intl.NumberFormat}}
   */
  currencyFormatters: {},
  /**
   * An Intl.NumberFormat for the given currency, using the locale declared for
   * it in Catalogue.currencies where there is one.
   *
   * The number of decimal places is deliberately left to Intl, which knows
   * which currencies have minor units: GBP formats to 2dp, VND and XAF to 0.
   *
   * @param {string} currency eg. "GBP"
   * @returns {Intl.NumberFormat}
   */
  currencyFormatter(currency) {
    if (!this.currencyFormatters[currency]) {
      const locale = this.currencyLocale(currency)
      let formatter
      try {
        /* narrowSymbol keeps the symbol unqualified - "$1,234.50" rather than
         * en-GB's default "US$1,234.50" - and resolves a symbol for several
         * currencies that would otherwise print as their ISO code. */
        formatter = new Intl.NumberFormat(locale, {
          style: 'currency',
          currency: currency,
          currencyDisplay: 'narrowSymbol',
        })
      } catch (e) {
        // narrowSymbol is ES2020; older engines throw a RangeError on it.
        formatter = new Intl.NumberFormat(locale, {
          style: 'currency',
          currency: currency,
        })
      }
      this.currencyFormatters[currency] = formatter
    }
    return this.currencyFormatters[currency]
  },
  /**
   * @param {string} currency eg. "GBP"
   * @returns {string} eg. "en-GB"
   */
  currencyLocale(currency) {
    // Catalogue isn't loaded on every page.
    if (typeof Catalogue != 'undefined' && Catalogue.currencies[currency]) {
      return Catalogue.currencies[currency].locale ||
        this.defaultCurrencyLocale
    }
    return this.defaultCurrencyLocale
  },
  /**
   * Formats number n like a price
   *
   * Omitting `currency` means "this is GBP". Passing one that's null or empty
   * means "this has a currency but it hasn't loaded yet" - most of the getters
   * feeding this read a lazily-fetched catalogue or basket - and formats as
   * unknown rather than silently picking GBP, which would render a EUR
   * reseller's prices with a pound sign for as long as the load takes.
   *
   * @param {number | string | null} n
   * @param {?string} [currency] eg. "GBP"
   * @returns {string}
   */
  price(n, currency = 'GBP') {
    if (n === null || n === undefined || n === '') {
      return translation.get('global_unknown')
    }
    if (!currency) {
      return translation.get('global_unknown')
    }
    // Some models carry the code lowercased ("gbp").
    currency = String(currency).toUpperCase()

    const currencyValue = this.currencyFormatter(currency).format(+n)

    /**
     * If Intl could not identify the symbol for the currency it falls back to
     * printing the ISO code, so substitute our own symbol. This currently
     * handles AED, BIF, DZD, OMR and SAR.
     */
    if (
      currencyValue.includes(currency) &&
      typeof Catalogue != 'undefined' &&
      Catalogue.currencies[currency]
    ) {
      return currencyValue.replace(
        currency,
        Catalogue.currencies[currency].symbol
      )
    }

    return currencyValue
  },
  /**
   * The number of decimal places a currency is written with: 2 for GBP, 0 for
   * VND, 3 for OMR.
   *
   * @param {string} currency eg. "GBP"
   * @returns {number}
   */
  currencyFractionDigits(currency) {
    return this.currencyFormatter(String(currency).toUpperCase())
      .resolvedOptions().maximumFractionDigits
  },
  /**
   * Splits a formatted price into the pieces the shop pages render in
   * separately styled spans: a large major part and a small minor one, with
   * the symbol on whichever side this currency puts it.
   *
   * Group separators stay with the major part ("1,234"), the decimal separator
   * with the minor one (".50"), and `minor` is empty for a currency with no
   * minor unit. A minus sign goes in the major part too - it can't live with
   * the symbol, which the templates fetch separately through
   * currencySymbolBefore, without an amount to take a sign from. The literal spacing Intl puts between number and symbol is
   * dropped - the spans lay themselves out.
   *
   * @param {number | string | null} n
   * @param {?string} [currency] eg. "GBP"
   * @returns {{symbolBefore: string, symbolAfter: string, major: string, minor: string}}
   */
  priceParts(n, currency = 'GBP') {
    if (n === null || n === undefined || n === '' || !currency) {
      return {
        symbolBefore: '',
        symbolAfter: '',
        major: translation.get('global_unknown'),
        minor: '',
      }
    }
    // Some models carry the code lowercased ("gbp").
    currency = String(currency).toUpperCase()

    let symbol = ''
    let major = ''
    let minor = ''
    let seenDigits = false
    let symbolLeads = true
    for (const part of this.currencyFormatter(currency).formatToParts(+n)) {
      switch (part.type) {
        case 'currency':
          symbol = part.value
          // A minus sign is emitted before the symbol, so ask for digits
          // rather than for anything at all in `major`.
          symbolLeads = !seenDigits
          break
        case 'integer':
          seenDigits = true
          major += part.value
          break
        case 'minusSign':
        case 'plusSign':
        case 'group':
          major += part.value
          break
        case 'decimal':
        case 'fraction':
          minor += part.value
          break
        default:
          // "literal": the space between number and symbol, and nothing else.
          break
      }
    }

    // As in price(), Intl prints the ISO code for currencies it can't symbolise.
    if (
      symbol === currency &&
      typeof Catalogue != 'undefined' &&
      Catalogue.currencies[currency]
    ) {
      symbol = Catalogue.currencies[currency].symbol
    }

    return {
      symbolBefore: symbolLeads ? symbol : '',
      symbolAfter: symbolLeads ? '' : symbol,
      major: major,
      minor: minor,
    }
  },
  /**
   * The currency symbol, for the side of the number it belongs on in the
   * shop's split price display. One of this pair is always empty: VND trails
   * its symbol, GBP leads with it.
   *
   * @param {?string} currency eg. "GBP"
   * @returns {string}
   */
  currencySymbolBefore(currency) {
    return this.priceParts(0, currency).symbolBefore
  },
  /**
   * @see currencySymbolBefore
   * @param {?string} currency eg. "GBP"
   * @returns {string}
   */
  currencySymbolAfter(currency) {
    return this.priceParts(0, currency).symbolAfter
  },
  /**
   * Formats number n to just its whole units, grouped the way the currency
   * groups them ("1,234" in GBP, "1.234" in VND). The counterpart of
   * priceTail, and the replacement for a bare Math.trunc, which gave an
   * ungrouped number and disagreed with priceTail about rounding.
   *
   * @param {number | string | null} n
   * @param {?string} [currency] eg. "GBP"
   * @returns {string}
   */
  priceMajor(n, currency = 'GBP') {
    return this.priceParts(n, currency).major
  },
  /**
   * Formats number n to just include the fraction component, with its decimal
   * separator (".50"). Empty for a currency with no minor unit, such as VND.
   *
   * @param {number | string | null} n
   * @param {?string} [currency] eg. "GBP"
   * @returns {string}
   */
  priceTail(n, currency = 'GBP') {
    // No "Unknown" here: a missing price is reported once, by the major part
    // this one is rendered beside, rather than twice.
    return this.priceParts(n, currency).minor
  },
  /**
   * @param {?(Date|string)} d
   * @param {{ format: ?(boolean|string) }} options
   * @returns {?string}
   */
  time(d, options = { format: true }) {
    return d && tdUtils.createTime(d, options)
  },
  /**
   * @param {?string} d
   * @param {{ format: ?(boolean|string) }} options
   * @returns {?string}
   */
  timeString(ds, options = { format: true }) {
    return ds && this.time(ds, options)
  },
  /**
   *
   * @param {?number} bytes
   * @returns {?string} eg. "10MB" or "576GB"
   */
  xB(bytes) {
    if (bytes === null) return null
    if (bytes == Infinity) return translation.get('global_ublimited')
    const BYTE_SIZES = ['B', 'KB', 'MB', 'GB', 'TB', 'EB']
    const power = Math.floor(Math.log(bytes) / Math.log(1024))
    return Math.round(bytes / 1024 ** power) + BYTE_SIZES[power]
  },
}
Site.Format.preferGB = false

/* Most pages put `format: Site.Format` in their Vue data, and Vue 2 walks an
 * observed object's enumerable properties, formatter cache and all. Nothing
 * renders from that cache, so hide it. */
Object.defineProperty(Site.Format, 'currencyFormatters', {
  enumerable: false,
  writable: true,
})

Vue.directive('fade-page-until', {
  bind(el, binding) {
    Site.hidePage()
    setTimeout(() => Site.showPage(), 1000)
  },
  inserted(el, binding) {
    if (binding.value) {
      Site.showPage()
    }
  },
  update(el, binding) {
    if (binding.value && !binding.oldValue) {
      Site.showPage(0.2)
    }
  },
})

Vue.directive('fade-unless', {
  inserted(el, binding) {
    if (!binding.value) {
      el.style.opacity = '0'
    }
  },
  update(el, binding) {
    if (binding.value && !binding.oldValue) {
      $(el).fadeTo(200, 1)
    } else if (binding.oldValue && !binding.value) {
      $(el).fadeTo(200, 0)
    }
  },
})

Vue.directive('fade-until', {
  inserted(el, binding) {
    if (!binding.value) {
      el.style.opacity = '0'
    }
  },
  update(el, binding) {
    if (binding.value && !binding.oldValue) {
      $(el).fadeTo(200, 1)
    }
  },
})

/**
 * Sets a select2-backed vue-select's min-width to the width of its widest
 * option, so the control never renders narrower than its longest item.
 *
 * Usage (the binding value is the options array passed to the vue-select):
 *   vue-select(v-fit-to-widest-option="packageOptions" ...)
 *
 * Options are measured from the bound array rather than the DOM: with
 * `infinite-scroll` the select2 data adapter empties the native <select>,
 * so there are no <option> nodes to read.
 */
function fitSelectToWidestOption(el, options) {
  if (!options || !options.length) {
    return
  }

  // select2 inserts its container as the next sibling of the <select>.
  const select2 = $(el).data('select2')
  const container =
    (select2 && select2.$container && select2.$container[0]) ||
    (el.nextElementSibling &&
    el.nextElementSibling.classList.contains('select2-container')
      ? el.nextElementSibling
      : null)

  // select2 initialises asynchronously, so retry until the container exists.
  if (!container) {
    setTimeout(() => fitSelectToWidestOption(el, options), 60)
    return
  }

  const selection = container.querySelector('.select2-selection')
  const rendered = container.querySelector('.select2-selection__rendered')
  const style = window.getComputedStyle(rendered || selection || container)

  const sizer = document.createElement('span')
  sizer.style.position = 'absolute'
  sizer.style.visibility = 'hidden'
  sizer.style.whiteSpace = 'nowrap'
  sizer.style.fontFamily = style.fontFamily
  sizer.style.fontSize = style.fontSize
  sizer.style.fontWeight = style.fontWeight
  document.body.appendChild(sizer)

  let widest = 0
  for (const option of options) {
    const text = (option && typeof option === 'object') ? option.text : option
    sizer.textContent = text != null ? text : ''
    widest = Math.max(widest, sizer.offsetWidth)
  }
  document.body.removeChild(sizer)

  // The text sits inside the rendered element, which sits inside the bordered
  // selection box; sum the horizontal padding/border of both (the rendered
  // element's right padding reserves space for the dropdown arrow).
  const horizontalChrome = (element) => {
    if (!element) {
      return 0
    }
    const s = window.getComputedStyle(element)
    return (parseFloat(s.paddingLeft) || 0) +
      (parseFloat(s.paddingRight) || 0) +
      (parseFloat(s.borderLeftWidth) || 0) +
      (parseFloat(s.borderRightWidth) || 0)
  }

  const width = Math.ceil(widest + horizontalChrome(rendered) + horizontalChrome(selection))

  // Set width as well as min-width so the control shrinks from select2's
  // default `width: 100%`. Left non-important so a stylesheet rule (e.g. the
  // domain-input component's `width: auto !important`) can still override it.
  container.style.width = `${width}px`
  container.style.minWidth = `${width}px`
}

Vue.directive('fit-to-widest-option', {
  inserted(el, binding) {
    fitSelectToWidestOption(el, binding.value)
  },
  update(el, binding) {
    if (binding.value !== binding.oldValue) {
      fitSelectToWidestOption(el, binding.value)
    }
  },
})

function dateFilterBinding() {
  Vue.filter(
    'dateString',
    /**
     * Generate a date string
     *
     * @param {string|Date} date
     * @param {{ format: ?(boolean|string), time: boolean, utc: boolean }} options
     *
     * @return {?string}
     */
    (date, options = { format: true, time: false, utc: false }) => {
      if (typeof date === 'string') {
        return Site.Format.dateString(date, options)
      }

      return Site.Format.date(date, options)
    }
  )

  Vue.filter(
    'dateTimeString',
    /**
     * Generate a date string with time included
     *
     * @param {string|Date} date
     * @param {{ format: ?(boolean|string), time: boolean, utc: boolean }} options
     *
     * @return {?string}
     */
    (date, options = { format: true, time: true, utc: false }) => {
      if (typeof date === 'string') {
        return Site.Format.dateTimeString(date, options)
      }

      return Site.Format.dateTime(date, options)
    }
  )

  Vue.filter(
    'dateTimeStringFromNow',
    /**
     * Generate a date string with time included
     *
     * @param {string|Date} date
     * @param {{ format: ?(boolean|string), time: boolean, utc: boolean }} options
     *
     * @return {?string}
     */
    (date, options = { format: true, time: true, utc: false }) => {
      if (typeof date === 'string') {
        return Site.Format.dateTimeStringFromNow(date, options)
      }

      return Site.Format.dateTime(date, options)
    }
  )

  Vue.filter(
    'dateStringUTC',
    /**
     * Generate a date string forcing UTC
     *
     * @param {string|Date} date
     * @param {{ format: ?(boolean|string), time: boolean, utc: boolean }} options
     *
     * @return {?string}
     */
    (date, options = { format: true, time: false, utc: true }) => {
      if (typeof date === 'string') {
        return Site.Format.dateString(date, options)
      }

      return Site.Format.date(date, options)
    }
  )

  Vue.filter(
    'dateTimeStringUTC',
    /**
     * Generate a date string with time included forcing UTC
     *
     * @param {string|Date} date
     * @param {{ format: ?(boolean|string), time: boolean, utc: boolean }} options
     *
     * @return {?string}
     */
    (date, options = { format: true, time: true, utc: true }) => {
      if (typeof date === 'string') {
        return Site.Format.dateTimeString(date, options)
      }

      return Site.Format.dateTime(date, options)
    }
  )

  Vue.filter(
    'timeString',
    /**
     * Generate a time string
     *
     * @param {string|Date} date
     * @param {{ format: ?(boolean|string) }} options
     *
     * @return {?string}
     */
    (date, options = { format: true }) => {
      if (typeof date === 'string') {
        return Site.Format.timeString(date, options)
      }

      return Site.Format.time(date, options)
    }
  )

  Vue.filter(
    'monthString',
    /**
     * Generate a month string (MMMM-YY)
     *
     * @param {string|Date} date
     * @param {{ format: ?(boolean|string) }} options
     *
     * @return {?string}
     */
    (date, options = { format: null }) => {
      if (typeof date === 'string') {
        return Site.Format.monthString(date, options)
      }

      return Site.Format.month(date, options)
    }
  )
}

dateFilterBinding()

/**
 * Formats a price for display, in the given currency.
 *
 * This is the template-side entry point for Site.Format.price - prefer it over
 * concatenating a currency symbol onto a number, which hardcodes a leading
 * symbol and 2dp and so gets currencies such as VND wrong.
 *
 *   {{ $price(item.price, currency) }}
 *
 * @param {number | string | null} n
 * @param {?string} [currency] eg. "GBP". Defaults to GBP when not known.
 * @returns {string}
 */
Vue.prototype.$price = function (n, currency = 'GBP') {
  return Site.Format.price(n, currency)
}

/**
 * Returns keyboard focus to whatever opened a modal once it closes.
 *
 * Bootstrap only does this for data-bs-toggle triggers; modals opened with
 * bootstrap.Modal.getOrCreateInstance(el).show() otherwise drop focus to the
 * top of the page. Skipped when focus has already moved somewhere real, or
 * another modal is now open.
 */
;(() => {
  /** @type {WeakMap<Element, HTMLElement>} */
  const openers = new WeakMap()

  document.addEventListener('show.bs.modal', (event) => {
    const modal = /** @type {Element} */ (event.target)
    const active = document.activeElement
    if (active instanceof HTMLElement && active !== document.body && !modal.contains(active)) {
      openers.set(modal, active)
    }
  })

  document.addEventListener('hidden.bs.modal', (event) => {
    const modal = /** @type {Element} */ (event.target)
    const opener = openers.get(modal)
    openers.delete(modal)
    if (!opener || !opener.isConnected || document.querySelector('.modal.show')) {
      return
    }
    const active = document.activeElement
    if (!active || active === document.body || modal.contains(active)) {
      opener.focus()
    }
  })
})()
